'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var App = require('app');
var AppState = require('app_state');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var MultiInput = require('components/common/views/multi_input_view');
var Notification = require('utils/notification');

var Permissions = Backbone.Model.extend({
    defaults: {
        8000: false,
        8001: false,
        8002: false,
        8003: false,
        8004: false,
        8005: false,
    },

    stringToPermission: {
        billing: 8000,
        manageUser: 8001,
        design: 8002,
        add: 8003,
        remove: 8004,
        view: 8005,
    },

    initialize: function (attr) {
        // sets the values for all given permissions to true
        for (var i = 0; i < attr.permissions.length; i++) {
            this.set(attr.permissions[i], true);
        }
        // we just set all permissions, so we discard this array
        this.unset('permissions');
    },

    setPermission: function (perm, isGranted) {
        this.set(this.stringToPermission[perm], isGranted);
    },

    getPermissions: function () {
        // WARNING. Fails if new attributes are added to the model defined above
        var permissions = [];
        _.each(this.attributes, function (permission, index, attributes) {
            if (permission) {
                permissions.push(parseInt(index));
            }
        });
        return permissions;
    },

    hasAnyPermission: function () {
        return this.getPermissions().length > 0;
    },

    getSelectedPermission: function () {
        if (this.get(8004) && this.get(8003)) {
            return 'full';
        }
        if (this.get(8003)) {
            return 'add';
        }
        if (this.get(8005)) {
            return 'view';
        }
        return 'none';
    },
});

var CompanyPermissionsDialogView = AbstractFormView.extend({
    template: require('components/profile/templates/company_permissions_dialog'),

    ui: {
        permission: '.js-perm-set',
        save: '#js-save',
        email: '#js-email-input',
        billing: '#js-billing',
        manageUser: '#js-manageUser',
        design: '#js-design',
        deviceAccess: '#js-device-permission',
    },

    events: {
        'click @ui.permission': 'setPermission',
        'click @ui.save': 'save',
        'changed.bs.select @ui.deviceAccess': 'updateDevicePermission',
    },

    regions: {
        emailInput: '#js-email-region',
    },

    childEvents: {
        destroy: function () {
            this.items = this.emailInputView.getItems();
        },
    },

    initialize: function (options) {
        this.items = [];
        // this.initMultiInput();
        this.newUser = options.newUser;
        var self = this;
        AbstractFormView.prototype.initialize.apply(this, [
            {
                inputFields: {
                    'js-email': {
                        method: 'callback',
                        validIfNotVisible: true,
                        validationCB: function () {
                            return self.emailInputView.validate();
                        },
                        flashThis: function () {
                            return $('#js-email-input').siblings('.bootstrap-tagsinput');
                        },
                    },
                },
                errors: options.errors,
                formData: options.formData,
                cleanHook: this.cleanEmailErrors,
            },
        ]);

        this.permissions = new Permissions({
            permissions: this.model.get('permissions'),
        });
    },

    serializeData: function () {
        var data = Backbone.Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.newUser = this.newUser;
        data.permissions = [
            {
                id: 'js-billing',
                title: 'Rechnungen',
                permission: this.permissions.get(8000),
            },
            {
                id: 'js-manageUser',
                title: 'Nutzer',
                permission: this.permissions.get(8001),
            },
        ];
        data.devicePermissions = [
            { value: 'full', name: 'Voll' }, // i18n.TR('Voll')
            { value: 'add', name: 'Nur hinzufügen' }, // i18n.TR('Nur hinzufügen')
            { value: 'view', name: 'Nur sehen' }, // i18n.TR('Nur sehen')
            { value: 'none', name: 'Kein' }, // i18n.TR('Kein')
        ];
        data.selected =
            !this.permissions.get(8003) && !this.permissions.get(8004) && !this.permissions.get(8005)
                ? 'white'
                : 'inverse';
        data.hasAnyPermission = this.permissions.hasAnyPermission();
        data.selectedPermission = this.permissions.getSelectedPermission();
        return data;
    },

    onRender: function () {
        Misc.initSelectPicker();
        this.initMultiInput();
        if (this.newUser) {
            this.showChildView('emailInput', this.emailInputView);
        }
    },

    onShow: function () {
        Misc.initSelectPicker();
        if (this.newUser) {
            this.showChildView('emailInput', this.emailInputView);
        }
    },

    onBeforeShow: function () {
        $('.modal-dialog').addClass('modal-sm');
    },

    onBeforeDestroy: function () {
        $('.modal-dialog').removeClass('modal-sm');
    },

    updateDevicePermission: function () {
        var p = $(this.ui.deviceAccess).val();

        this.selectedPermission = p;
        this.permissions.set(8003, p == 'full' || p == 'add');
        this.permissions.set(8004, p == 'full');
        this.permissions.set(8005, p == 'view');

        this.render();
    },

    setPermission: function (e) {
        e.preventDefault();

        var elm = $(e.currentTarget).parent().attr('id').split('-');
        var permission = elm[elm.length - 1];
        var isGranted = $(e.currentTarget).hasClass('js-enabled');

        this.permissions.setPermission(permission, isGranted);
        this.render();
    },

    cleanEmailErrors: function () {
        delete this.errors.email;
    },

    save: function (e) {
        e.preventDefault();

        if (!this.allFieldsValid()) {
            return;
        }

        this.model.set('permissions', this.permissions.getPermissions());
        if (this.model.get('permissions').length === 0) {
            App.hideModal();
            return;
        }
        if (this.options.newUser && this.emailInputView.getItems()) {
            this.model.set('emails', this.emailInputView.getItems());
        }

        Decorator.disableElement('.modal-dialog');

        var self = this;
        this.model.save(
            {},
            {
                wait: true,
                success: function (model, errors) {
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Rechte erfolgreich gespeichert'));

                    // reload current route -> might update side menu
                    Backbone.history.loadUrl(Backbone.history.fragment);
                },
                error: function (model, errors) {
                    // 400 response = either Hacker, or some users already have permssions
                    if (
                        errors.status === 400 &&
                        // multiple users? -> treat as success
                        (!errors.responseJSON || self.emailInputView.getItems().length > 1)
                    ) {
                        App.hideModal();
                        Notification.show(
                            'warning',
                            i18n.TR('Erfolg'),
                            i18n.TR('Einige Nutzer sind bereits Administratoren.')
                        );
                        return;
                    }
                    self.errors = errors;
                    App.refreshModal(self);
                },
            }
        );
    },

    initMultiInput: function () {
        if (!this.options.newUser) {
            return;
        }
        this.emailInputView = MultiInput.GetMultiEmailView({
            items: this.items,
            response: this.errors,
            error500Text: i18n.TR('Die Vergabe der Administratorrechte ist fehlgeschlagen.'),
            error400Text: i18n.TR('Dieser Nutzer ist bereits Administrator.'),
        });
    },
});

module.exports = CompanyPermissionsDialogView;
